import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Controller, Scene } from 'react-scrollmagic';
import Snowfall from 'react-snowfall'
import { useInView } from 'react-intersection-observer';
import { Parallax } from 'react-parallax';

import { colors } from '../shared/variables'

// SVG's - Hero
import { ReactComponent as Logo } from '../images/logo.svg';
import { ReactComponent as Curly } from '../images/curly1.svg';
import { ReactComponent as Tree1 } from '../images/tree1.svg';
import { ReactComponent as Arrow } from '../images/arrow.svg';

// SVG's - Intro
import { ReactComponent as Cloud } from '../images/cloud.svg';

// SVG's - Bear Scene
import { ReactComponent as CloudScene } from '../images/cloud_scene.svg';
import { ReactComponent as Bear } from '../images/bear.svg';
import { ReactComponent as Mountains } from '../images/mountains.svg';
import { ReactComponent as Star } from '../images/star.svg';
import { ReactComponent as Forest } from '../images/forest.svg';

// SVG's - Kids
// import { ReactComponent as Stocking1 } from '../images/stocking1.svg';
// import { ReactComponent as Stocking2 } from '../images/stocking2.svg';
// import { ReactComponent as Stocking3 } from '../images/stocking3.svg';

// SVG's - April
import April1 from '../images/april1.jpg';
import April2 from '../images/april2.jpg';
import April3 from '../images/april3.jpg';
import { ReactComponent as Frame1A } from '../images/frame1a.svg';
import { ReactComponent as Frame1B } from '../images/frame1b.svg';
import { ReactComponent as Frame1C } from '../images/frame1c.svg';
import { ReactComponent as Frame1D } from '../images/frame1d.svg';
import { ReactComponent as Sock } from '../images/sock.svg';
import { ReactComponent as Mic } from '../images/mic.svg';

// SVG's - Rayaan
import Rayaan1 from '../images/rayaan1.jpg';
import Rayaan2 from '../images/rayaan2.jpg';
import Rayaan3 from '../images/rayaan3.jpg';
import { ReactComponent as Frame2A } from '../images/frame2a.svg';
import { ReactComponent as Frame2B } from '../images/frame2b.svg';
// import { ReactComponent as Frame2C } from '../images/frame2c.svg';
import { ReactComponent as Frame2D } from '../images/frame2d.svg';
import { ReactComponent as Sock2 } from '../images/sock2.svg';
import { ReactComponent as Pancake } from '../images/pancake.svg';

// SVG's - Izzy
import Izzy1 from '../images/izzy1.jpg';
import Izzy2 from '../images/izzy2.jpg';
import Izzy3 from '../images/izzy3.jpg';
// import { ReactComponent as Frame3A } from '../images/frame3a.svg';
import { ReactComponent as Frame3B } from '../images/frame3b.svg';
// import { ReactComponent as Frame3C } from '../images/frame3c.svg';
// import { ReactComponent as Frame3D } from '../images/frame3d.svg';
import { ReactComponent as Sock3 } from '../images/sock3.svg';
import { ReactComponent as Whale } from '../images/whale.svg';

// SVG's - Connection
import { ReactComponent as Ornament1 } from '../images/ornament1.svg';
import { ReactComponent as Ornament2 } from '../images/ornament2.svg';
import { ReactComponent as Ornament3 } from '../images/ornament3.svg';
import { ReactComponent as Ornament4 } from '../images/ornament4.svg';
import { ReactComponent as Ornament5 } from '../images/ornament5.svg';
import { ReactComponent as Ornament6 } from '../images/ornament6.svg';
import { ReactComponent as GiftScene } from '../images/gift_scene.svg';
import ChocWalk from '../images/choc_walk_2022.jpg';
import ChocWalkMob from '../images/choc_walk_2022_mobile.jpg';
import { ReactComponent as Bear2 } from '../images/bear2.svg';
import { ReactComponent as PawPrints } from '../images/paw_prints.svg';

// SVG's - Outro
import { ReactComponent as PawPrints2 } from '../images/paw_prints2.svg';
import { ReactComponent as LogoWordMark } from '../images/logo_wordmark.svg';
import { ReactComponent as LogoChoc } from '../images/choc_logo.svg';
import { ReactComponent as Plus } from '../images/plus.svg';
import { ReactComponent as Tree2 } from '../images/tree2.svg';
import { ReactComponent as YTFrame } from '../images/yt_frame.svg';

// const easeOutCubic = (percent) => {
//   return 1 - Math.pow(1 - percent, 3);
// };

const easeInCubic = (percent) => {
  return percent * percent * percent;
  }


const PageStyled = styled.div`
  background: ${colors.whiteChocolate};
  overflow: hidden;
  font-family: 'Inter';

  .sticky {
    height: 100vh;
    width: 100%;
  }

  .svg-mobile {
    display: none;

    @media (min-width: 768px) and (max-width: 1280px) {
      position: relative;
      top: auto;
      right: auto;
      left: auto;
      margin: 10vh auto;
      display: block;
      z-index: 2;
    }

    @media (max-width: 767px) {
      position: relative;
      top: auto;
      right: auto;
      left: auto;
      margin: 10vh auto;
      display: block;
      z-index: 2;
    }
  }

  .svg-desktop {
    @media (min-width: 768px) and (max-width: 1280px) {
      display: none;
    }
    @media (max-width: 767px) {
      display: none;
    }
  }
`;

const Hero = styled.div`
  /* min-height: 800px; */
  height: 100vh;
  position: relative;
  z-index: 2;
`;

const Curly1 = styled(Curly)`
  position: absolute;
  top: 36px;
  left: 46px;

  @media (max-width: 767px) {
    display: none;
  }
`;

const Curly2 = styled(Curly)`
  position: absolute;
  top: 36px;
  right: 46px;
  transform: scaleX(-1);

  @media (max-width: 767px) {
    display: none;
  }
`;

const Curly3 = styled(Curly)`
  position: absolute;
  bottom: 36px;
  right: 46px;
  transform: scale(-1, -1);

  @media (max-width: 767px) {
    display: none;
  }
`;

const Curly4 = styled(Curly)`
  position: absolute;
  bottom: 36px;
  left: 46px;
  transform: scaleY(-1);

  @media (max-width: 767px) {
    display: none;
  }
`;

const HeroContainer = styled.div`
  text-align: center;
  /* padding-top: 100px; */
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* @media (max-width: 767px) {
    padding-top: 40px;
  } */
`;

const Cursive = styled.div`
  font-family: 'Amrinnatica';
  color: ${colors.whiteChocolate};
  font-size: 36px;
  margin-top: 50px;

  @media (max-width: 767px) {
    margin-top: 70px;
  }
`;

const H1 = styled.h1`
  color: ${colors.whiteChocolate};
  text-transform: uppercase;
  font-weight: 800;
  font-size: 160px;
  margin-top: 65px;
  margin-bottom: 0px;
  letter-spacing: -8px;

  @media (min-width: 768px) and (max-width: 1280px) {
    font-size: 120px;
    line-height: 100%;
    margin-top: 51px;
    letter-spacing: -3px;
    margin-left: -3px;
  }

  @media (max-width: 767px) {
    font-size: 70px;
    line-height: 100%;
    margin-top: 51px;
    letter-spacing: -3px;
    margin-left: -3px;
  }
`;

const ScrollHint = styled.div`
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%) translateY(50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledTree1 = styled(Tree1)`
  margin-top: 30px;
  transform-origin: center bottom;
`;

const StyledArrow = styled(Arrow)`
  transform-origin: center bottom;

  @media (max-width: 767px) {
    opacity: 0;
  }
`;


const H2 = styled.h2`
  font-size: 68px;
  font-weight: normal;
  letter-spacing: -2.8px;
  max-width: 1150px;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 136px;
  color: ${colors.chamoisee};
  position: relative;
  z-index: 1;

  @media (min-width: 768px) and (max-width: 1280px) {
    font-size: 42px;
    padding: 0 30px;
  }

  @media (max-width: 767px) {
    font-size: 34px;
    padding: 0 20px;
    line-height: 150%;
  }

  a {
    color: ${colors.chamoisee};
    text-decoration: none;
    border-bottom: 4px solid ${colors.chamoisee};
    transition: color 0.3s ease, border 0.3s ease;

    &:hover {
      color: ${colors.amaranthPurple};
      border-bottom: 4px solid ${colors.amaranthPurple};
    }
  }

  .sticky {
    height: auto;
  }
`;

// INTRO
const Intro = styled.div`
  text-align: center;
  padding-top: 105px;

  ${H2} {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .sticky {
    height: auto;
    z-index: 0;
  }
`;

const Cursive2 = styled(Cursive)`
  position: relative;
  margin-top: 32px;
  color: ${colors.amaranthPurple};
  z-index: 0;
`;

const StyledCloud = styled(Cloud)`
  position: relative;
  z-index: 0;
`

const BearScene = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 50px;
`;

const StyledCloudScene = styled(CloudScene)`
  position: relative;
  left: 50vw;
  transform: translateX(-50%);
`;

const StyledBear = styled(Bear)`
  position: absolute;
  bottom: -5vw;
  left: 50%;
  transform: translateX(-50%);
`;
const StyledStar = styled(Star)`
  position: absolute;
  top: -20px;
  right: calc(50% - 560px);

  @media (min-width: 768px) and (max-width: 1280px) {
    right: 50%;
    transform: translateX(50%);
  }

  @media (max-width: 767px) {
    right: 50%;
    transform: translateX(50%);
  }
`;

const StyledForest = styled(Forest)`
  margin-top: -68px;
  position: relative;
  left: 50vw;
  transform: translateX(-50%);
`;

const StyledMountains = styled(Mountains)`
  margin-top: 4.6vw;
  position: relative;
  left: 50vw;
  transform: translateX(-50%);
`;

const SegwayText = styled.p`
  color: ${colors.chamoisee};
  font-size: 36px;
  margin-top: 50vh;
  letter-spacing: -1px;
  margin-bottom: 40vh;

  @media (max-width: 767px) {
    font-size: 24px;
    margin-left: auto;
    margin-right: auto;
    max-width: 295px;
  }
`;

const KidNameContainer = styled.div`
  text-align: center;
  padding-top: 108px;
  height: calc(100vh - 108px);
  top: 0px;
  width: 100%;
  position: ${(props) => (props.sticky ? 'fixed' : 'relative')};
  transform: translate(0px, 0px);
  z-index: 2;
`;

const KidName = styled.h3`
  font-size: 200px;
  color: ${(props) => (props.active ? colors.whiteChocolate : colors.antiqueRuby)};
  margin: 0px;
  line-height: 90%;
  letter-spacing: -14px;
  transition: color 0.3s ease;

  @media (max-width: 767px) {
    font-size: 100px;
    letter-spacing: -5px;
    line-height: 100%;
  }
`;

// const StyledStocking1 = styled(Stocking1)`
//   position: absolute;
//   top: 40px;
//   left: calc(50% - 270px);
// `;

// const StyledStocking2 = styled(Stocking2)`
//   position: absolute;
//   bottom: -90px;
//   left: calc(50% - 374px);
// `;

// const StyledStocking3 = styled(Stocking3)`
//   position: absolute;
//   top: calc(50% - 25px);
//   right: calc(50% - 460px);
// `;

const StyledGiftScene = styled(GiftScene)`
  @media (max-width: 767px) {
    width: 172%;
    transform: translateX(-50%);
    left: 50%;
    position: relative;
  }
`;

const Connection = styled.div`
  position: relative;
  text-align: center;
  padding-top: 226px;
  padding-bottom: 105px;

  ${H2} {
    margin-top: 0px;

    .sticky div {
      transform: translateY(-50%);
    }
  }

  picture {
    margin-top: 115px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 1310px;
    padding: 0 25px;
    display: block;
    box-sizing: border-box;

    @media (max-width: 767px) {
      margin-top: 84px;
    }

    img {
      width: 100%;
    }
  }

  ${Cursive} {
    margin-top: 10px;
    color: ${colors.chamoisee};

    @media (max-width: 767px) {
      font-size: 28px;
    }
  }

  ${SegwayText} {
    margin-bottom: 0px;
  }
`;

const SegwayTextWrapper = styled.div`
  text-align: center;
  margin-top: 0px;
  margin-bottom: 100px;

  ${SegwayText} {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`

const SegwayTextWrapper2 = styled(SegwayTextWrapper)`
  margin-top: 40vh;
`;

const SegwayBear = styled.div`
  /* margin-top: -440px; */

  /* @media (min-width: 768px) and (max-width: 1280px) {
    margin-top: 0px;
  }

  @media (max-width: 767px) {
    margin-top: 0px;
  } */
`;

const StyledPawPrints = styled(PawPrints)`
  bottom: 0px;

  @media (min-width: 768px) and (max-width: 1280px) {
    display: none;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const StyledBear2 = styled(Bear2)`
  margin-left: 80px;
  @media (min-width: 768px) and (max-width: 1280px) {
    margin-left: 0px;
  }
  @media (max-width: 767px) {
    margin-left: 0px;
  }
`;

const StyledOrnament1 = styled(Ornament1)`
  position: absolute;
  top: -400px;
  left: calc(50% - 40px);
  z-index: 2;

  @media (max-width: 767px) {
    top: -100px;
  }
`;
const StyledOrnament2 = styled(Ornament2)`
  position: absolute;
  top: -300px;
  left: calc(50% - 670px);
  z-index: 2;

  @media (max-width: 767px) {
    top: -100px;
    left: calc(50% - 170px);
  }
`;
const StyledOrnament6 = styled(Ornament6)`
  position: absolute;
  top: -100px;
  right: calc(50% - 675px);
  z-index: 2;

  @media (max-width: 767px) {
    top: 50px;
    right: calc(50% - 175px);
  }
`;

const StyledOrnament3 = styled(Ornament3)`
  position: absolute;
  top: -200px;
  left: calc(50% - 200px);
  z-index: 2;
`;
const StyledOrnament4 = styled(Ornament4)`
  position: absolute;
  top: -400px;
  left: 50%;
  z-index: 2;
`;
const StyledOrnament5 = styled(Ornament5)`
  position: absolute;
  top: 0px;
  right: calc(50% - 670px);
  z-index: 2;
`;

const OrnamentContainer = styled.div`
  position: relative;
`;

const Colab = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  margin-top: 200px;
  justify-content: center;
  align-items: center;
  grid-gap: 10px;

  a {
    opacity: 1;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.6;
    } 
  }

  .logo-choc {
    position: relative;
    top: -7px;
  }
`;

const StyledLogoWordMark = styled(LogoWordMark)``;

const StyledTree2 = styled(Tree2)`
  display: block;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 200px;
`;

const Outro = styled.div`
  position: relative;
  text-align: center;
  z-index: 2;

  ${H1} {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    line-height: 82%;
    margin-top: 30px;
    margin-bottom: 0px;

    @media (min-width: 768px) and (max-width: 1280px) {
      font-size: 80px;
      width: 600px;
    }

    @media (max-width: 767px) {
      font-size: 80px;
      width: 375px;
    }

    .mobile {
      display: none;

      @media (max-width: 767px) {
        display: inline-block;
      }
    }

    .desktop {
      @media (max-width: 767px) {
        display: none;
      }
    }
  }

  iframe {
    position: relative;
    width: 100%;
    max-width: 650px;
    height: 366px;

    @media (max-width: 767px) {
      width: 350px;
      height: 197px;
    }
  }

  ${SegwayText} {
    color: ${colors.whiteChocolate};
    margin: 230px auto 0px;
    max-width: 800px;

    @media (min-width: 768px) and (max-width: 1280px) {
      /* font-size: 22px; */
      max-width: 600px;
    }

    @media (max-width: 767px) {
      font-size: 18px;
      max-width: 325px;
    }
  }

  ${Cursive} {
    margin-top: 25px;

    @media (max-width: 767px) {
      font-size: 28px;
      /* max-width: 225px; */
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

const RedBackground = styled.div`
  background: ${colors.amaranthPurple};
  opacity: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
`;

const FrameBody = styled.p`
  color: ${colors.whiteChocolate};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  margin: 0px;
  width: calc(100% - 40px);
  text-align: center;
  font-size: 24px;
  letter-spacing: -1px;
  line-height: 140%;
  text-shadow: 0px 0px 2px ${colors.antiqueRuby};
  padding: 0 50px;
  box-sizing: border-box;
`;

const FrameDescription = styled.p`
  color: ${colors.whiteChocolate};
  font-style: italic;
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%) translateY(100%);
  margin: 0px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  text-shadow: 0px 0px 2px ${colors.antiqueRuby};
  box-sizing: border-box;
  padding: 0 50px;

  @media (max-width: 767px) {
    bottom: 0px;
  }
`;

const AprilContainer = styled.div`
  position: relative;
  width: 420px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 20vh;
  z-index: 2;

  @media (min-width: 768px) and (max-width: 1280px) {
    width: 350px;
    left: 50% !important; // Re-center all panels
    margin-bottom: 0px;
  }

  @media (max-width: 767px) {
    width: 350px;
    left: 50% !important; // Re-center all panels
    margin-bottom: 0px;
  }
  

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    height: 100%;
    padding: 52px;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
  }

  svg {
    width: 100%;
    height: auto;
  }
`;

const StyledSock = styled(Sock)`
  position: absolute;
  top: 50%;
  right: calc(100% + 100px);
  width: 100px !important;
`;

const StyledSock2 = styled(Sock2)`
  position: absolute;
  top: 70%;
  right: calc(100% + 100px);
  width: 100px !important;
`;

const StyledMic = styled(Mic)`
  position: absolute;
  top: 25%;
  left: calc(100% + 300px);
  width: 150px !important;
`;

const StyledMic2 = styled(Mic)`
  position: absolute;
  top: 25%;
  left: calc(100% + 300px);
  width: 150px !important;
  transform: rotate(-45deg);
`;

const StyledPancake = styled(Pancake)`
  position: absolute;
  top: 75%;
  left: calc(100% + 300px);
  width: 150px !important;
`;

const StyledPancake2 = styled(Pancake)`
  position: absolute;
  top: 45%;
  right: calc(100% + 300px);
  width: 150px !important;
  transform: rotate(55deg);
`;

const StyledSock3 = styled(Sock3)`
  position: absolute;
  top: 30%;
  left: calc(100% + 100px);
  width: 70px !important;
`;

const StyledWhale = styled(Whale)`
  position: absolute;
  top: 25%;
  left: calc(100% + 300px);
  width: 150px !important;
`;

const StyledWhale2 = styled(Whale)`
  position: absolute;
  top: 25%;
  right: calc(100% + 300px);
  width: 150px !important;
  transform: rotate(-65deg) scaleX(-1);
`;

const AprilContainer2 = styled(AprilContainer)`
  left: calc(50% - 300px);
  img {
    padding: 60px;
  }

  ${FrameDescription} {
    bottom: 20px;
  }
`;

const AprilContainer3 = styled(AprilContainer)`
  left: calc(50% - 150px);

  img {
    padding: 45px;
  }

  ${FrameDescription} {
    bottom: 10px;

    @media (min-width: 768px) and (max-width: 1280px) {
      box-sizing: border-box;
      padding: 0 50px;
    }

    @media (max-width: 767px) {
      bottom: 0px;
      padding: 0 50px;
      box-sizing: border-box;
    }
  }
`;

const AprilContainer4 = styled(AprilContainer)`
  left: calc(50% + 300px);
  margin-bottom: 100vh;

  ${FrameBody} {
    @media (min-width: 768px) and (max-width: 1280px) {
      padding: 0 10px;
    }
    @media (max-width: 767px) {
      padding: 0 10px;
    }
  }
`;

const RayaanContainer = styled(AprilContainer)`
  ${FrameDescription} {
    bottom: 5px;
  }
`;

const RayaanContainer2 = styled(RayaanContainer)`
  left: calc(50% - 300px);

  img {
    padding: 40px;
  }
`;

const RayaanContainer3 = styled(RayaanContainer)`
  left: calc(50% + 300px);

  img {
    padding: 50px;
  }
`;

const RayaanContainer4 = styled(RayaanContainer)`
  left: calc(50% + 300px);
  margin-bottom: 100vh;

  ${FrameBody} {
    @media (min-width: 768px) and (max-width: 1280px) {
      padding: 0 10px;
    }
    @media (max-width: 767px) {
      padding: 0 10px;
    }
  }
`;

const IzzyContainer = styled(AprilContainer)`
  img {
    padding: 45px;
  }
  ${FrameDescription} {
    bottom: -10px;
  }
`;

const IzzyContainer2 = styled(IzzyContainer)`
  left: calc(50% - 300px);
`;

const IzzyContainer3 = styled(IzzyContainer)`
  left: calc(50% + 300px);
`;

const IzzyContainer4 = styled(IzzyContainer)`
  left: calc(50% - 300px);

  ${FrameBody} {
    @media (min-width: 768px) and (max-width: 1280px) {
      padding: 0px;
    }
    @media (max-width: 767px) {
      padding: 0px;
    }
  }
`;

const StyledYTFrame = styled(YTFrame)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 780px;
  height: auto;

  @media (max-width: 767px) {
    display: none;
  }
`;

const YTFrameWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -40px;

  @media (min-width: 768px) and (max-width: 1280px) {
    top: -10px;
  }

  @media (max-width: 767px) {
    top: -10px;
  }
`;

const SegwayFixedWrapper = styled.div`
  position: relative;
`

const SegwayFixedCSS = css`
  position: fixed;
  top: 50%;
  z-index: 0;
`;

const SegwayTextFixed = styled(SegwayText)`
  position: absolute;
  top: 0px;
  width: 100%;
  max-width: none;
  margin: 0px;
  transform: translate(0px, 0px);
  ${(props) => (props.pinnedSegway && SegwayFixedCSS)};
`;

const Page = () => {
  // Background Alt Color Opacity
  const [backgroundOpacity, setBackgroundOpacity] = useState(1);

  // Checkpoints used for Background Opacity Logic
  const [checkpoint1, setCheckpoint1] = useState(false);
  const [checkpoint2, setCheckpoint2] = useState(false);
  const [checkpoint3, setCheckpoint3] = useState(false);

  // Kid Names
  const [stickyNames, setStickyNames] = useState(false);
  const [showEndName, setShowEndName] = useState(false);
  const [activeApril, setActiveApril] = useState(false);
  const [activeRayaan, setActiveRayaan] = useState(false);
  const [activeIzzy, setActiveIzzy] = useState(false);

  // Segway Pin
  const [pinnedSegway, setPinnedSegway] = useState(false);

  // Starting Name Threshold
  const [refNames, inViewNames, entry] = useInView({
    threshold: 1,
    initialInView: true
  });

  // Ending Name Threshold
  const [refNamesEnd, inViewNamesEnd, entryEnd] = useInView({
    threshold: 1,
    initialInView: true
  });

  // April Threshold
  const [refApril, inViewApril] = useInView();
  useEffect(() => {
    inViewApril ? setActiveApril(true) : setActiveApril(false);
  }, [inViewApril])

  // Rayaan Threshold
  const [refRayaan, inViewRayaan] = useInView();
  useEffect(() => {
    inViewRayaan ? setActiveRayaan(true) : setActiveRayaan(false);
  }, [inViewRayaan])

  // Izzy Threshold
  const [refIzzy, inViewIzzy] = useInView();
  useEffect(() => {
    inViewIzzy ? setActiveIzzy(true) : setActiveIzzy(false);
  }, [inViewIzzy])

  // Fired when Starting names reaches top of screen
  useEffect(() => {
    setStickyNames(entry?.boundingClientRect?.y > 0 ? false : true);
  }, [entry, inViewNames])

  // Fired when Ending names reaches top of screen
  useEffect(() => {
    setShowEndName(entryEnd?.boundingClientRect?.y > 0 ? false : true);
  }, [entryEnd, inViewNamesEnd])

  return (
  <Controller>
    <PageStyled>
      {/* {[...Array(50)].map((x, i) =>
        <div className='snow' key={i} />
      )} */}

      <Snowfall
        color={colors.whiteChocolate}
        snowflakeCount={50}
        style={{
          position: 'fixed',
          zIndex: '2',
          top: '0px',
          left: '0px'
        }}
      />

      {/* Alt Red Background Component */}
      <RedBackground style={{ opacity: `${backgroundOpacity}`}} />

      {/* Hero Section */}
      <Parallax
        style={{ overflow: 'visible' }}
        renderLayer={percentage => {
          const truePercent = percentage - 1;
          // console.log('percentage (hero): ', percentage);
          // console.log('truePercent (hero): ', truePercent);
          return (
          <Hero>
            <Curly1 />
            <Curly2 />
            <Curly3 />
            <Curly4 />
            
            <HeroContainer style={{ transform: `translateY(${truePercent * -400}px)`}}>
              <Logo />
              <Cursive>Wishing you</Cursive>
              <H1>Happy Holidays</H1>
              <StyledTree1/>
            </HeroContainer>
            <ScrollHint>
              <Scene
                triggerHook={'onCenter'}
                duration={250}
              >
                {(progress, event) => {
                  // console.log('progress (arrow): ', progress);
                  event?.state === 'AFTER' ? setCheckpoint1(true) : setCheckpoint1(false);
                  event !== 'init' && setBackgroundOpacity(1 - progress)

                  return(
                    <StyledArrow style={{ transform: `translateY(-${1 + truePercent * 100}px)`}} />
                  )
                }}
              </Scene>
            </ScrollHint>
          </Hero>
        )}}
      />

      {/* Intro Section */}
      <Intro>
        {/* <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
          <StyledCloud style={{ top: '200px', transform: `translateY(-${easeOutCubic(percentage) * 200}px)`}}/>
        )}/>
        <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
          <Cursive2 style={{ top: '200px', transform: `translateY(-${easeOutCubic(percentage) * 200}px)`}}>Season’s Greetings</Cursive2>
        )}/> */}
        {/* <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
          <H2 style={{ top: '200px', transform: `translateY(-${easeOutCubic(percentage) * 200}px)`}}>It’s better to give than receive, and this year you’re helping us give to <a target="_blank" href="https://www.choc.org/" rel="noreferrer">Children’s Health of Orange County</a>. With your support of Five & Done, we can support some truly special kids.</H2>
        )}/> */}

        <StyledCloud/>
        <Cursive2>Season’s Greetings</Cursive2>
        <Scene duration={600} offset={'50%'} pin={{ pushFollowers: false }} enabled={true}>
          <div className="sticky">
            <H2>It’s better to give than receive, and this year you’re helping us give to <a target="_blank" href="https://www.choc.org/" rel="noreferrer">Children’s Health of Orange County</a>.</H2>
          </div>
        </Scene>
        <Scene duration={600} offset={'50%'} pin={{ pushFollowers: false }} enabled={true}>
          <div className="sticky">
            <H2>With your support of Five & Done, we can support some truly special kids.</H2>
          </div>
        </Scene>
        

        <BearScene>
          <StyledCloudScene />
          <StyledMountains />
          <StyledForest />
          <StyledBear />
          <StyledStar />
        </BearScene>
        <SegwayFixedWrapper>
          <SegwayTextFixed pinnedSegway={pinnedSegway}>Kids like...</SegwayTextFixed>
          <Scene
            triggerHook={'onCenter'}
            duration={250}
          >
            {(progress, event) => {
              // console.log('progress (segway): ', progress);
              event?.state === 'AFTER' ? setCheckpoint2(true) : setCheckpoint2(false);
              checkpoint1 && setBackgroundOpacity(progress);
              checkpoint1 && progress !== 0 ? setPinnedSegway(true) : setPinnedSegway(false);
              checkpoint1 && checkpoint2 && setPinnedSegway(false);

              return(
                <SegwayText style={{ opacity: '0' }}>Kids like...</SegwayText>
              )
            }}
          </Scene>
        </SegwayFixedWrapper>
      </Intro>
      
      {/* Kid's Section */}
      <div ref={refNames}></div>
      <KidNameContainer sticky={stickyNames} style={{ opacity: showEndName ? '0' : '1' }}>
        <KidName active={activeApril}>April</KidName>
        <KidName active={activeRayaan}>Rayaan</KidName>
        <KidName active={activeIzzy}>Izzy</KidName>
      </KidNameContainer>
      <KidNameContainer style={{ opacity: '0' }}>
        <KidName>April</KidName>
        <KidName>Rayaan</KidName>
        <KidName>Izzy</KidName>
      </KidNameContainer>

      {/* April Section */}
      <div ref={refApril}>
        <AprilContainer>
          <Frame1C />
          <img loading="lazy" src={April2} alt="April" />
          <FrameDescription>April happily navigates the world<br />with her prosthetic leg.</FrameDescription>
          <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
            <div style={{ position: 'relative', top: '-300px', transform: `translateY(-${percentage * 200}px)`}}>
              <StyledSock className='svg-desktop'/>
            </div>
          )}/>
        </AprilContainer>
        <StyledSock className='svg-mobile'/>
        <AprilContainer2>
          <Frame1A />
          <img loading="lazy" src={April1} alt="April" />
          <FrameDescription>She is 9 years old.</FrameDescription>
          <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
            <div style={{ position: 'relative', top: '-400px', transform: `translateY(-${percentage * 400}px)`}}>
              <StyledMic className='svg-desktop'/>
            </div>
          )}/>
        </AprilContainer2>
        <StyledMic className='svg-mobile'/>
        <AprilContainer3>
          <Frame1B />
          <img loading="lazy" src={April3} alt="April" />
          <FrameDescription>She represents CHOC around the country as a Local Children’s Miracle Network Champion.</FrameDescription>
          <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
            <div style={{ position: 'relative', top: '-400px', transform: `translateY(-${percentage * 200}px)`}}>
              <StyledMic2 className='svg-desktop'/>
            </div>
          )}/>
        </AprilContainer3>
        <StyledMic2 className='svg-mobile'/>
        <AprilContainer4>
          <Frame1D />
          <FrameBody>She loves to sing, dance, and perform in local theater productions.</FrameBody>
        </AprilContainer4>
      </div>

      {/* Rayaan Section */}
      <div ref={refRayaan}>
        <RayaanContainer>
          <Frame2B />
          <img loading="lazy" src={Rayaan1} alt="Rayaan" />
          <FrameDescription>Rayaan is 9 years old.</FrameDescription>
          <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
            <div style={{ position: 'relative', top: '-300px', transform: `translateY(-${percentage * 200}px)`}}>
              <StyledSock2 className='svg-desktop'/>
            </div>
          )}/>
        </RayaanContainer>
        <StyledSock2 className='svg-mobile'/>
        <RayaanContainer2>
          <Frame2A />
          <img loading="lazy" src={Rayaan2} alt="Rayaan" />
          <FrameDescription>Rayaan with his mom, at CHOC.</FrameDescription>
          <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
            <div style={{ position: 'relative', top: '-400px', transform: `translateY(-${percentage * 400}px)`}}>
              <StyledPancake className='svg-desktop'/>
            </div>
          )}/>
        </RayaanContainer2>
        <StyledPancake className='svg-mobile'/>
        <RayaanContainer3>
          <Frame2B />
          <img loading="lazy" src={Rayaan3} alt="Rayaan" />
          <FrameDescription>He has earned top honors as the 2021 IHOP Kid Chef Champion.</FrameDescription>
          <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
            <div style={{ position: 'relative', top: '-400px', transform: `translateY(-${percentage * 200}px)`}}>
              <StyledPancake2 className='svg-desktop'/>
            </div>
          )}/>
        </RayaanContainer3>
        <StyledPancake2 className='svg-mobile'/>
        <RayaanContainer4>
          <Frame2D />
          <FrameBody>He loves Roblox, swimming, riding his bike and, of course, his favorite breakfast item—pancakes.</FrameBody>
        </RayaanContainer4>
      </div>

      {/* Izzy Section */}
      <div ref={refIzzy}>
        <IzzyContainer>
          <Frame3B />
          <img loading="lazy" src={Izzy1} alt="Izzy" />
          <FrameDescription>Izzy is 13 years old.</FrameDescription>
          <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
            <div style={{ position: 'relative', top: '-300px', transform: `translateY(-${percentage * 200}px)`}}>
              <StyledSock3 className='svg-desktop'/>
            </div>
          )}/>
        </IzzyContainer>
        <StyledSock3 className='svg-mobile'/>
        <IzzyContainer2>
          <Frame3B />
          <img loading="lazy" src={Izzy2} alt="Izzy" />
          <FrameDescription>Whale watching with mom.</FrameDescription>
          <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
            <div style={{ position: 'relative', top: '-400px', transform: `translateY(-${percentage * 400}px)`}}>
              <StyledWhale className='svg-desktop'/>
            </div>
          )}/>
        </IzzyContainer2>
        <StyledWhale className='svg-mobile'/>
        <IzzyContainer3>
          <Frame3B />
          <img loading="lazy" src={Izzy3} alt="Izzy" />
          <FrameDescription>Izzy, dressed as Amelia Earhart for Halloween.</FrameDescription>
          <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
            <div style={{ position: 'relative', top: '-400px', transform: `translateY(-${percentage * 200}px)`}}>
              <StyledWhale2 className='svg-desktop'/>
            </div>
          )}/>
        </IzzyContainer3>
        <StyledWhale2 className='svg-mobile'/>
        <IzzyContainer4>
          <Frame2D />
          <FrameBody>She loves whale watching, the ocean, music, and nature documentaries.</FrameBody>
        </IzzyContainer4>
      </div>

      {/* Ending Names Duplicate */}
      <div ref={refNamesEnd}></div>
      <KidNameContainer style={{ opacity: showEndName ? '1' : '0' }}>
        <KidName active={activeApril}>April</KidName>
        <KidName active={activeRayaan}>Rayaan</KidName>
        <KidName active={activeIzzy}>Izzy</KidName>
      </KidNameContainer>
      
      {/* Company Connection Section */}
      <Connection>
        <Scene
          triggerHook={'onEnter'}
          duration={250}
        >
          {(progress, event) => {
            // console.log('progress (izzy): ', progress);
            event?.state === 'AFTER' ? setCheckpoint3(true) : setCheckpoint3(false);
            checkpoint1 && checkpoint2 && setBackgroundOpacity(1 - progress)

            return(
              <OrnamentContainer>
                <Parallax
                  style={{
                    position: 'absolute',
                    overflow: 'visible',
                    height: '100%',
                    width: '100%'
                  }}
                  renderLayer={percentage => (
                    <>
                      <StyledOrnament1 style={{ transform: `translateY(-${percentage * 600}px)`}} />
                      <StyledOrnament2 style={{ transform: `translateY(-${percentage * 200}px)`}}/>
                      {/* <StyledOrnament3 style={{ transform: `translateY(-${percentage * 100}px)`}}/> */}
                      {/* <StyledOrnament4 style={{ transform: `translateY(-${percentage * 200}px)`}}/> */}
                      {/* <StyledOrnament5 style={{ transform: `translateY(-${percentage * 200}px)`}}/> */}
                      <StyledOrnament6 style={{ transform: `translateY(-${percentage * 200}px)`}}/>
                    </>
                  )}
                />
                <H2>
                  <Scene duration={600} offset={'50%'} pin={{ pushFollowers: false }} enabled={true}>
                    <div className="sticky">CHOC impacts so many families and our family is no different.</div>
                  </Scene>
                  <Scene duration={600} offset={'50%'} pin={{ pushFollowers: false }} enabled={true}>
                    <div className="sticky">If Izzy looks familiar, it’s because she’s part of the Five & Done family – maybe the bravest and most spirited of our 19 kids.</div>
                  </Scene>
                  <Scene duration={600} offset={'50%'} pin={{ pushFollowers: false }} enabled={true}>
                    <div>As a long time patient of CHOC, she has benefited from their care and support over years of surgeries, specialist visits, and check-ups.</div>
                  </Scene>
                </H2>
                <Parallax
                  style={{
                    position: 'absolute',
                    overflow: 'visible',
                    height: '100%',
                    width: '100%'
                  }}
                  renderLayer={percentage => (
                    <>
                      {/* <StyledOrnament1 style={{ transform: `translateY(-${percentage * 600}px)`}} /> */}
                      {/* <StyledOrnament2 style={{ transform: `translateY(-${percentage * 200}px)`}}/> */}
                      <StyledOrnament3 style={{ transform: `translateY(-${percentage * 200}px)`}}/>
                      <StyledOrnament4 style={{ transform: `translateY(-${percentage * 400}px)`}}/>
                      <StyledOrnament5 style={{ transform: `translateY(-${percentage * 300}px)`}}/>
                      {/* <StyledOrnament6 style={{ transform: `translateY(-${percentage * 200}px)`}}/> */}
                    </>
                  )}
                />
              </OrnamentContainer>
            )
          }}
        </Scene>
        <Scene duration={500} offset={'50%'} pin={{ pushFollowers: false }} enabled={true}>
          <SegwayTextWrapper>
            <SegwayText>So, this isn’t just another donation to us.</SegwayText>
          </SegwayTextWrapper>
        </Scene>
        <StyledGiftScene />
        <Parallax style={{ overflow: 'visible' }} renderLayer={percentage => (
          <>
            <picture>
              <source srcSet={ChocWalk} media="(min-width: 768px)"></source>
              <img style={{ clipPath: `inset(0% ${easeInCubic(1 - percentage) * 20}%)` }} loading="lazy" src={ChocWalkMob} alt="Choc Walk 2022" />
            </picture>
          </>
        )}/>
        <Cursive>CHOC Walk 2022</Cursive>
        <Scene duration={500} offset={'50%'} pin={{ pushFollowers: false }} enabled={true}>
          <SegwayTextWrapper2>
            <SegwayText>It's something we believe in.</SegwayText>
          </SegwayTextWrapper2>
        </Scene>
        <SegwayBear>
          <StyledPawPrints />
          <StyledBear2 />
        </SegwayBear>
      </Connection>

      {/* Outro Section */}
      <Outro>
        <Scene
          triggerHook={'0.75'}
          duration={250}
        >
          {(progress, event) => {
            // console.log('progress (arrow): ', progress, event);
            // event?.state === 'AFTER' ? setCheckpoint4(true) : setCheckpoint4(false);
            checkpoint1 && checkpoint2 && checkpoint3 && setBackgroundOpacity(progress)

            return(
              <PawPrints2 />
            )
          }}
        </Scene>
        <Cursive>For this year’s holiday season,</Cursive>
        <H1 as={`h2`}>Thank you for your <span className="desktop">partnership</span><span className="mobile">partner</span><span className="mobile">-ship</span></H1>

        <YTFrameWrapper>
          <StyledYTFrame />
          <iframe width="650" height="366" src="https://www.youtube.com/embed/dXebBcTRVp0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </YTFrameWrapper>

        <SegwayText>We will be donating $10,000 to the CHOC Walk to help provide even better care for kids like Izzy, April, and Rayaan.</SegwayText>
        <Cursive>From your friends at Five & Done</Cursive>
        <Colab>
          <a href="https://www.fiveanddone.com/" target='_blank' rel="noreferrer">
            <StyledLogoWordMark/>
          </a>
          <Plus />
          <a className="logo-choc" href="https://www.choc.org/" target='_blank' rel="noreferrer">
            <LogoChoc />
          </a>
        </Colab>
        <StyledTree2 />
      </Outro>
    </PageStyled>
  </Controller>
)};

export default Page;